import { useGeoPricing, setCurrencyOverride } from "../../lib/geoPricing";

const CURRENCIES = ["INR", "USD", "EUR", "GBP", "AED"];

export default function CurrencySwitcher({ variant = "light" }) {
    const { currency } = useGeoPricing();
    return (
        <select
            aria-label="Display currency"
            data-testid="currency-switcher"
            value={currency}
            onChange={(e) => setCurrencyOverride(e.target.value)}
            className={`bg-transparent text-[11px] tracking-[0.15em] uppercase font-semibold cursor-pointer focus:outline-none py-1 ${
                variant === "dark" ? "text-primary-foreground/85 hover:text-accent" : "text-muted-foreground hover:text-primary"
            }`}
        >
            {CURRENCIES.map((c) => (
                <option key={c} value={c} className="text-foreground bg-background">{c}</option>
            ))}
        </select>
    );
}
